module.exports = __webpack_public_path__ + "static/media/scribbbleLogo.626115a3.png";